import { v4 as uuidv4 } from 'uuid';
import zbase32 from 'zbase32';
import { Buffer } from 'buffer';

const generateID = (prefix) => {
  return `${prefix}_${zbase32.encode(uuidv4({}, Buffer.alloc(16)))}`;
};
export default generateID;
